import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M23.25 13.75C22.0208 8.96354 17.3021 5.25 11.9948 5.25C6.68229 5.25 1.97917 8.96354 0.75 13.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        ></path>
        <path
          d="M16.0832 13.3333C16.0832 15.5885 14.255 17.4167 11.9998 17.4167C9.74463 17.4167 7.9165 15.5885 7.9165 13.3333C7.9165 11.0781 9.74463 9.25 11.9998 9.25C14.255 9.25 16.0832 11.0781 16.0832 13.3333Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        ></path>
      </svg>
    </>
  );
};
